"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _childrenUserManage = require("@/api/userCenter/childrenUserManage");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "AddSubAccount",
  components: {
    dragDialog: _DragDialog.default
  },
  props: {
    sysAccountId: {
      type: String,
      default: ''
    },
    accountNo: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      formAddChildren: {
        roleObject: {},
        portData: '',
        portCode: '',
        portObject: '',
        roleName: '',
        roleCode: '',
        sysRoleId: '',
        officeAbbrev: ''
      },
      rules: {
        accountNo: [{
          required: true,
          message: '请选择角色',
          trigger: 'change'
        }],
        roleObject: [{
          required: true,
          message: '请选择角色',
          trigger: 'change'
        }],
        portData: [{
          required: true,
          message: '请选择角色信息',
          trigger: 'change'
        }]
      },
      loading: null
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    selectPortChange: function selectPortChange(row, data) {
      this.formAddChildren.portObject = data;
      this.formAddChildren.portCode = data.portCode;
      this.formAddChildren.roleCode = data.roleCode;
      this.formAddChildren.roleName = data.roleName;
      this.formAddChildren.sysRoleId = data.sysRoleId;
      this.formAddChildren.officeAbbrev = data.officeAbbrev;
    },
    addChildrenPostClick: function addChildrenPostClick() {
      var _this = this;
      this.$refs.formAddChildrenRef.validate(function (valid) {
        if (valid) {
          var params = {
            sysRoleId: _this.formAddChildren.sysRoleId,
            roleCode: _this.formAddChildren.roleCode,
            sysAccountId: _this.sysAccountId,
            accountNo: _this.accountNo,
            ebSysAccountRolePortItems: [{
              officeCode: "SITC_JPA",
              portCode: _this.formAddChildren.portObject.portCode,
              privilegeType: 1,
              portName: _this.formAddChildren.portObject.portName,
              portNameCn: _this.formAddChildren.portObject.portNameCn
            }]
          };
          _this.loading = (0, _utils.load)();
          (0, _childrenUserManage.addSubAccountRolePort)(params).then(function (res) {
            if (res.success) {
              _this.$parent.setInitDialogAssigningRoleVisible(false);
              _this.$parent.searchFormData();
              _this.$parent.getTableChildrenData();
              _this.$message({
                message: _this.$t('userCenter.childrenUserManage.addChildrenSuccess'),
                type: 'success'
              });
            } else {
              _this.$message({
                message: res.errorMessages[0] || _this.$t('userCenter.childrenUserManage.addChildrenError'),
                type: 'error'
              });
            }
          }).catch(function (err) {
            _this.$message({
              message: err.errorMessages[0] || _this.$t('userCenter.childrenUserManage.addChildrenError'),
              type: 'error'
            });
          }).finally(function () {
            _this.loading.close();
          });
        }
      });
    },
    opened: function opened() {},
    closed: function closed() {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.$refs['formAddChildrenRef'].clearValidate();
        _this2.$refs['formAddChildrenRef'].resetFields();
      });
    }
  }
};